/*
 * サブシステム名：
 * 機能名：日報一覧
 * 表示項目カスタマイズ(光陽テクノサービス)
 */

import D2PRMD0011 from '@/views/PRM/D2PRMD0011.js'

import date from '@/ddv2.library/date'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PRMD0011,
  name: 'NippoListCustomForKts',
  data: () => ({
    // 検索条件
    conditions: {
      unkoYoteiStartYmdString: null,
      unkoYoteiEndYmdString: null,
      tokuisakiId: null,
      hacchusakiId: null,
      jomuinJininId: null,
      sharyoId: null,
      meisaiHeadFlg: false
    },
    custoMizeHeaders: [
      { text: '編集', value: 'actions', sortable: false, width: '20px' },
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '乗務員', value: 'jomuinJininNmSei' },
      { text: '傭車先', value: 'hacchusakiNm' },
      { text: '自動車表示名', value: 'jidoshaHyojiNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '積地', value: 'hatsuchiDisp' },
      { text: '卸地', value: 'chakuchiDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '請求金額合計', value: 'seikyuKingakuGokeiDisp', align: 'end' },
      { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
      { text: '支払金額合計', value: 'shiharaiKingakuGokeiDisp', align: 'end' },
      { text: '荷主書面(受)', value: 'chumonshoReceiveZumiFlgDisp', align: 'center' },
      { text: '荷主書面(交付)', value: 'chumonkakuninshoSendZumiFlgDisp', align: 'center' },
      { text: '傭車書面(交付)', value: 'hacchushoSendZumiFlgDisp', align: 'center' },
      { text: '実運送報告', value: 'motoukeHokokuZumiFlgDisp', align: 'center' },
      { text: '注文番号', value: 'chumonNo' },
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '受注No', value: 'juchuNo' },
      { text: '#', value: 'meisaiOrder' }
    ]
  }),
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuJissekiId = String(elem.keikakujissekikey) + String(elem.juchuNo)
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.jissekiKakuninZumiFlgDisp = elem.jissekiKakuninZumiFlg ? '〇' : ''
        elem.haishaTantoshaDisp = elem.haishaTantoJininCd ? elem.haishaTantoJininCd + ' : ' + elem.haishaTantoJininNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.sharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.torokuNo : ''
        elem.jomuinDisp = elem.jomuinJininCd ? elem.jomuinJininCd + ' : ' + elem.jomuinJininNmSei : ''
        elem.dojoshaDisp = elem.joshuJininCd ? elem.joshuJininCd + ' : ' + elem.joshuJininNmSei : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : ''
        elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.warimashiKyoriTankaDisp = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.shiharaiYoteiYmdDisp = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        elem.seikyuKingakuGokeiDisp = elem.seikyuKingakuGokei ? filter.numericFormatter(elem.seikyuKingakuGokei) : ''
        elem.shiharaiKingakuGokeiDisp = elem.shiharaiKingakuGokei ? filter.numericFormatter(elem.shiharaiKingakuGokei) : ''
        elem.chumonshoReceiveZumiFlgDisp = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        elem.chumonkakuninshoSendZumiFlgDisp = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        elem.hacchushoSendZumiFlgDisp = elem.hacchushoSendZumiFlg ? '送付済' : ''
        elem.motoukeHokokuZumiFlgDisp = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        elem.hatsuchiOdoMater = elem.hatsuchiOdoMater ? filter.numericFormatter(elem.hatsuchiOdoMater) : ''
        elem.chakuchiOdoMater = elem.chakuchiOdoMater ? filter.numericFormatter(elem.chakuchiOdoMater) : ''
        return elem
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return -1 }
        if (a.unkoYmd === b.unkoYmd) {
          if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
          if (a.trUnkoJissekiId === b.trUnkoJissekiId) {
            if (a.meisaiOrder > b.meisaiOrder) { return 1 }
            if (a.meisaiOrder === b.meisaiOrder) { return 0 }
            return -1
          }
          return 0
        }
        return 1
      /*
      }).sort((a, b) => {
        if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
        if (a.trUnkoJissekiId === b.trUnkoJissekiId) { return 0 }
        return 1
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      */
      })
    }
  },
  methods: {
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        unkoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        unkoYoteiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        jomuinJininId: null,
        tokuisakiId: null,
        ninushiId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: false
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.unkoYoteiStartYmdString.slice(-5) + '～' + initConditions.unkoYoteiEndYmdString.slice(-5),
        tokuisakiNm: '',
        yoshasakiNm: '',
        jomuinJininNm: '',
        jidoshaHyojiNm: ''
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
